





















































import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop, Watch } from "vue-property-decorator";
import moment from "moment-timezone";
import { userModule } from "@/utils/store-acessor";

@Component({})
export default class ChallengeCountdown extends Vue {
  private countdownHandler: number | null = null;
  @userModule.Getter("timezone") timezone!: string;
  @Prop({ required: true }) label!: string;
  @Prop({ required: true }) endDate!: Date;

  days: number | null = null;
  hours: number | null = null;
  minutes: number | null = null;
  seconds: number | null = null;

  mounted() {
    this.onDeadlineChange();
  }

  @Watch("endDate")
  onDeadlineChange() {
    if (this.countdownHandler === null && this.endDate) {
      const eventTime = moment(this.endDate)
        .tz(this.timezone)
        .unix();
      const currentTime = moment(new Date())
        .tz(this.timezone)
        .unix();

      let diffTime = (eventTime - currentTime) * 1000;
      // @ts-ignore
      this.countdownHandler = setInterval(() => {
        diffTime -= 1000;
        const duration = moment.duration(diffTime, "milliseconds");
        if (diffTime <= 0) {
          this.onFinish();
          return;
        }

        this.days = Math.floor(duration.asDays());
        this.hours = duration.hours();
        this.minutes = duration.minutes();
        this.seconds = duration.seconds();
      }, 1000);
    }
  }

  destroyed() {
    clearInterval(this.countdownHandler || 0);
  }

  @Emit("onFinish")
  onFinish() {
    if (this.countdownHandler) {
      clearInterval(this.countdownHandler);
    }

    this.days = 0;
    this.hours = 0;
    this.minutes = 0;
    this.seconds = 0;
  }

  get formattedDay(): string {
    const result = this.days ? this.days.toString() : this.formatZero;
    return `${result}`;
  }

  get formattedHours(): string {
    const result = this.hours ? this.hours.toString() : this.formatZero;
    return `${result}`;
  }

  get formattedMinutes(): string {
    const result = this.minutes ? this.minutes.toString() : this.formatZero;
    return `${result}`;
  }

  get formattedSeconds(): string {
    const result = this.seconds ? this.seconds.toString() : this.formatZero;
    return `${result}`;
  }

  get formatZero(): string {
    return this.allTimerIsZero ? "--" : "0";
  }

  get allTimerIsZero(): boolean {
    return this.days == 0 && this.hours == 0 && this.minutes == 0 && this.seconds == 0;
  }
}
